"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'SRStoreOrderDetailList',
      sourceApi: null,
      listLoading: '',
      list: [],
      currPage: 1,
      limit: 10,
      total: 0,
      showExprotDialog: false,
      // 导出
      exportForm: {
        exportYear: '' // 默认导出时间
      },
      exportFormRule: {
        exportYear: [{
          required: true,
          message: this.$t('common.pleaseSelect'),
          trigger: 'change'
        }]
      },
      downloadLoading: false,
      regionOptions: [],
      cityOptions: [],
      searchQuery: {
        rtlFullName: '',
        // 店名
        rtlRegion: null,
        // 省
        rtlCity: null,
        // 市
        rtlRtmCategory: '',
        retailerTypeList: [],
        empName: ''
      },
      tableTotalObj: null,
      lookupList: {}
    };
  },
  computed: {
    rtlRegionValue: function rtlRegionValue() {
      return this.searchQuery.rtlRegion ? this.searchQuery.rtlRegion.value : '';
    },
    rtlCityValue: function rtlCityValue() {
      return this.searchQuery.rtlCity ? this.searchQuery.rtlCity.value : '';
    }
  },
  watch: {
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    var currentYear = new Date().getFullYear();
    this.exportForm.exportYear = currentYear.toString();
    // 获取省市数据
    this.fetchRegionList();
    // 请求列表
    this.fetchListData(true);
    // 查找值
    this.getLookupTypeCode();
  },
  methods: {
    getLookupTypeCode: function getLookupTypeCode() {
      var _this = this;
      var param = {
        configItemCodeList: ['STORE_RTM_TYPE', 'STORE_CATEGORY']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this.lookupList) {
          _this.generateMapping(key, _this.lookupList[key] || []);
        }
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this2 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this2.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    provinceChangeEvent: function provinceChangeEvent(value) {
      this.searchQuery.rtlCity = null;
      this.cityOptions = value ? Array.isArray(value.children) && value.children.length ? value.children : [] : [];
    },
    fetchRegionList: function fetchRegionList() {
      var _this3 = this;
      var regionOptions = this.$store.getters.getRegionData('level_2');
      if (regionOptions.length) {
        this.regionOptions = regionOptions;
        return;
      }
      this.$api.common.getRegionList(2).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this3.regionOptions = responseData.data;
          _this3.$store.dispatch('baseData/saveRegionDataByLevel', {
            key: 'level_2',
            regionData: responseData.data
          });
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    getSummaries: function getSummaries(_ref) {
      var _this4 = this;
      var columns = _ref.columns;
      var sums = [];
      if (!this.tableTotalObj) {
        return sums;
      }
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = _this4.$t('common.total');
        } else {
          if (_this4.tableTotalObj.hasOwnProperty(column.property)) {
            sums[index] = _this4.tableTotalObj[column.property] == null ? '' : _this4.tableTotalObj[column.property];
          } else {
            sums[index] = '';
          }
        }
      });
      return sums;
    },
    resetData: function resetData() {
      this.searchQuery.rtlFullName = '';
      this.searchQuery.rtlRegion = '';
      this.searchQuery.rtlCity = '';
      this.searchQuery.rtlRtmCategory = '';
      this.searchQuery.retailerTypeList = [];
      this.searchQuery.empName = '';
      this.searchPageOneTable(true);
    },
    searchPageOneTable: function searchPageOneTable(updateTotalApi) {
      this.currPage = 1;
      this.fetchListData(updateTotalApi);
    },
    fetchListData: function fetchListData(updateTotalApi) {
      var _this5 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      this.listLoading = true;
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          rtlFullName: this.searchQuery.rtlFullName,
          rtlRegion: this.rtlRegionValue,
          rtlCity: this.rtlCityValue,
          rtlRtmCategory: this.searchQuery.rtlRtmCategory,
          retailerTypeList: this.searchQuery.retailerTypeList,
          empName: this.searchQuery.empName
        }
      };
      this.$api.reportModule.getSRStoreOrderList(param, this.sourceApi.token).then(function (res) {
        _this5.list = res.data.items || [];
        _this5.total = res.data.totalCount || 0;
        // 确保表格有数据，再去请求总和数据
        if (updateTotalApi) {
          _this5.fetchTableTotalData();
        } else {
          _this5.listLoading = false;
        }
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this5.listLoading = false;
      });
    },
    fetchTableTotalData: function fetchTableTotalData() {
      var _this6 = this;
      var param = {
        rtlFullName: this.searchQuery.rtlFullName,
        rtlRegion: this.rtlRegionValue,
        rtlCity: this.rtlCityValue,
        rtlRtmCategory: this.searchQuery.rtlRtmCategory,
        retailerTypeList: this.searchQuery.retailerTypeList,
        empName: this.searchQuery.empName
      };
      this.$api.reportModule.getStoreDetailTotal(param).then(function (res) {
        _this6.tableTotalObj = res.data || {};
        _this6.listLoading = false;
      }).catch(function () {
        _this6.listLoading = false;
      });
    },
    openExportDialog: function openExportDialog() {
      this.showExprotDialog = true;
    },
    closeExportDialog: function closeExportDialog() {
      this.showExprotDialog = false;
      this.$refs.exportStoreForm.resetFields();
    },
    submitExportDialog: function submitExportDialog() {
      var _this7 = this;
      this.$refs.exportStoreForm.validate(function (valid) {
        if (valid) {
          var fileName = "".concat(_this7.$t('route.srstoreorderdetaillist'), "_").concat(_this7.exportForm.exportYear);
          _this7.downloadExcel(fileName);
        }
      });
    },
    downloadExcel: function downloadExcel(name) {
      var _this8 = this;
      var param = {
        year: this.exportForm.exportYear
      };
      this.downloadLoading = true;
      this.$api.reportModule.exportSRStoreOrderList(param, this.sourceApi.token).then(function (res) {
        _this8.downloadLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
        setTimeout(function () {
          _this8.closeExportDialog();
        }, 500);
      }).finally(function () {
        _this8.downloadLoading = false;
      });
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};